import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  id: "sidebar-port",
  class: "nav-collapse kakugo"
}
const _hoisted_4 = {
  class: "sidebar-menu",
  id: "nav-accordion"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  class: "centered",
  style: {"margin-top":"7px"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", {
  class: "whiteColor",
  style: {"font-size":"0.9rem","margin-top":"-8px"}
}, "調整ページ一覧", -1)
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", {
  class: "whiteColor",
  style: {"font-size":"1rem","margin-top":"-8px"}
}, "調整カレンダー", -1)
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", {
  class: "whiteColor",
  style: {"font-size":"1rem","margin-top":"-8px"}
}, "調整カレンダー(共有)", -1)
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", {
  class: "whiteColor",
  style: {"font-size":"1rem","margin-top":"-8px"}
}, [
  /*#__PURE__*/_createTextVNode("振り分け"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("フォーム")
], -1)
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", {
  class: "whiteColor",
  style: {"font-size":"1rem","margin-top":"-8px"}
}, "レポート", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "fs11 whiteColor" }, "ヘルプ", -1)
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  class: "posFi w100 shadowContent ofh skyblueBg",
  style: {"top":"0","height":"50px","z-index":"100"}
}
const _hoisted_25 = { class: "w25 fl ofh" }
const _hoisted_26 = {
  class: "fl ml10",
  style: {"width":"40px","margin-top":"-10px"}
}
const _hoisted_27 = { class: "w75 fl" }
const _hoisted_28 = ["src"]
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  class: "posFi w100 with_shadow with_white_bg",
  style: {"bottom":"-2px","height":"70px","z-index":"10"}
}
const _hoisted_31 = {
  key: 0,
  class: "w25 fl with_white_bg"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = { class: "w25 fl with_white_bg" }
const _hoisted_35 = ["src"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = { class: "w25 fl with_white_bg" }
const _hoisted_38 = ["src"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = {
  key: 1,
  class: "w25 fl with_white_bg"
}
const _hoisted_41 = {
  class: "centered",
  style: {"margin-top":"15px"}
}
const _hoisted_42 = ["src"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", {
  class: /*#__PURE__*/_normalizeClass(`fs9 centered`)
}, "調整カレンダー", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIconMenu = _resolveComponent("UserIconMenu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_AdPromBusinessModal = _resolveComponent("AdPromBusinessModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isSP)
      ? (_openBlock(), _createElementBlock("aside", _hoisted_2, [
          (_ctx.rm.userInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("ul", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("p", _hoisted_6, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/logo/logo512x140_white.png`),
                      height: "20"
                    }, null, 8, _hoisted_7)
                  ]),
                  _hoisted_8,
                  _hoisted_9,
                  _createVNode(_component_UserIconMenu),
                  _hoisted_10,
                  _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => [
                      _createElementVNode("li", {
                        class: _normalizeClass(`sideMenuLi centered ${_ctx.currentPage == `rooms` ? `selected` : ``}`),
                        style: {"line-height":"50px","padding":"10px 0"}
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/navi/pages_wt.png`),
                          width: "20",
                          height: "20",
                          style: {"margin-top":"-3px"},
                          class: "top"
                        }, null, 8, _hoisted_11),
                        _hoisted_12
                      ], 2)
                    ]),
                    _: 1
                  }),
                  (_ctx.showAstagsPage())
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        class: _normalizeClass(`sideMenuLi centered ${_ctx.currentPage == `available_schedule` ? `selected` : ``} pointer`),
                        style: {"line-height":"50px","padding":"10px 0"},
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goAvailableSchedule && _ctx.goAvailableSchedule(...args)))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_white.png`),
                          width: "26",
                          height: "26",
                          class: "restricted_calendar"
                        }, null, 8, _hoisted_13),
                        _hoisted_14
                      ], 2))
                    : _createCommentVNode("", true),
                  false
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 1,
                        class: _normalizeClass(`sideMenuLi centered ${_ctx.currentPage == `client_available_schedule` ? `selected` : ``} pointer`),
                        style: {"line-height":"50px","padding":"10px 0"},
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goClientAvailableSchedule && _ctx.goClientAvailableSchedule(...args)))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_white.png`),
                          width: "26",
                          height: "26",
                          class: "restricted_calendar"
                        }, null, 8, _hoisted_15),
                        _hoisted_16
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.showAssignFormPage())
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 2,
                        class: _normalizeClass(`sideMenuLi centered ${_ctx.currentPage == `assign_form` ? `selected` : ``} pointer`),
                        style: {"line-height":"50px","padding":"10px 0"},
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goAssignForm && _ctx.goAssignForm(...args)))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/form_assign_wt.png`),
                          width: "24",
                          height: "22",
                          class: "restricted_calendar"
                        }, null, 8, _hoisted_17),
                        _hoisted_18
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.showReportsPage())
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 3,
                        class: _normalizeClass(`sideMenuLi centered ${_ctx.currentPage == `reports` ? `selected` : ``} pointer`),
                        style: {"line-height":"50px","padding":"10px 0"},
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goReports && _ctx.goReports(...args)))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/graph_white.png`),
                          width: "24",
                          height: "22",
                          class: "restricted_calendar"
                        }, null, 8, _hoisted_19),
                        _hoisted_20
                      ], 2))
                    : _createCommentVNode("", true),
                  _hoisted_21
                ]),
                _createElementVNode("div", {
                  class: "posFi ml15 centered pointer",
                  style: {"bottom":"10px"},
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goHelpCenter && _ctx.goHelpCenter(...args)))
                }, [
                  _createVNode(_component_IconHelp, {
                    color: `white`,
                    width: 34,
                    class: "ml5",
                    style: {"margin-top":"-3px","margin-right":"5px"}
                  }),
                  _hoisted_22
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("aside", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_UserIconMenu)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/logo/waaqLink_logo_white_flat.gif`),
                class: "serviceLogo fl",
                style: {"width":"130px","margin-left":"15px","margin-top":"20px"}
              }, null, 8, _hoisted_28),
              (_ctx.showPublicRoom())
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.$getAssetImageUrl(`/assets/icons/search_icon_wt.png`),
                    width: "30",
                    height: "30",
                    class: "fr",
                    style: {"margin-right":"10px","margin-top":"10px"},
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickSpSearchBox && _ctx.clickSpSearchBox(...args)))
                  }, null, 8, _hoisted_29))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            (_ctx.showPublicRoom())
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", {
                    class: "centered",
                    style: {"margin-top":"15px"},
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectCategoryTab(`public`)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(_ctx.imgRooms()),
                      width: "20",
                      height: "20",
                      style: {"margin-top":"-3px"}
                    }, null, 8, _hoisted_32),
                    _hoisted_33,
                    _createElementVNode("p", {
                      class: _normalizeClass(`fs9 centered ${_ctx.selectedTabName == `public` ? `skyblue` : ''}`)
                    }, "公開ページ", 2)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", {
                class: "centered",
                style: {"margin-top":"15px"},
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectCategoryTab(`active_in_progress`)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(_ctx.imgRooms()),
                  width: "20",
                  height: "20",
                  style: {"margin-top":"-3px"}
                }, null, 8, _hoisted_35),
                _hoisted_36,
                _createElementVNode("p", {
                  class: _normalizeClass(`fs9 centered ${_ctx.selectedTabName == `active_in_progress` ? `skyblue` : ''}`)
                }, "調整中", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", {
                class: "centered",
                style: {"margin-top":"15px"},
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectCategoryTab('upcoming_fixed')))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(_ctx.imgFix()),
                  width: "20",
                  height: "20",
                  style: {"margin-top":"-3px"}
                }, null, 8, _hoisted_38),
                _hoisted_39,
                _createElementVNode("p", {
                  class: _normalizeClass(`fs9 centered ${_ctx.selectedTabName == `upcoming_fixed` ? `skyblue` : ''}`)
                }, "確定", 2)
              ])
            ]),
            (_ctx.showPublicRoom())
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createVNode(_Transition, { name: "slide" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: "/available_schedule" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/navi/calendar_sp.png`),
                              width: "23",
                              height: "22",
                              style: {"margin-top":"-3px"}
                            }, null, 8, _hoisted_42),
                            _hoisted_43,
                            _hoisted_44
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])),
    _createVNode(_component_AdPromBusinessModal, { addFrom: `管理画面 サイドバー` })
  ]))
}